module.exports = __webpack_public_path__ + "img/sv87on.0b8f9aee.svg";